import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ErrorContainer from 'containers/business/ErrorContainer'
import businessRoutes from './route'

export function NotFound() {
  return (
    <Status code={404}>
      <div />
    </Status>
  )
}

function Status({ code, children }) {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) staticContext.status = code
        return children
      }}
    />
  )
}

export function routeIndexes(service) {
  const indexes = {
    business: businessRoutes,
  }
  return indexes[service]
}

export function serviceRouter(service, ssr = true, errorStatus = null) {
  return function() {
    return (
      <Switch>
        {routeIndexes(service).map((route, index) => (
          <Route key={index} {...route} />
        ))}
        {ssr ? (
          <Route component={NotFound} />
        ) : (
          <ErrorContainer status={errorStatus} />
        )}
      </Switch>
    )
  }
}
